import { GroupForBookingFormQuery } from '@website/types/graphqlOperations';
import { useForm } from 'react-hook-form';
import { AuthenticateForm } from '../auth/AuthenticationModal';
import { BookingFormOnSubmitValues } from './BookingForm';
import BookingFormLayout from './subComponents/BookingFormLayout';
import CheckoutPrices from './subComponents/CheckoutPrices';

export default function CheckoutLogin({
  group,
}: {
  group: GroupForBookingFormQuery['group'];
}) {
  const { register, setValue, watch } = useForm<BookingFormOnSubmitValues>({});

  return (
    <BookingFormLayout group={group}>
      <CheckoutPrices
        customerCreditBalance={0}
        group={group}
        register={register}
        setValue={setValue}
        watch={watch}
        hidePriceDetails
      />

      <div className="text-block pb-4">
        <h5>Log in or sign up to book</h5>
        <p className="text-sm text-muted">It just takes a few seconds.</p>
        <AuthenticateForm
          onSuccess={() =>
            window?.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth',
            })
          }
        />
      </div>
    </BookingFormLayout>
  );
}
